import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const projectNotFoundEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-project-not-found", jiraSpaEntry: "async-project-not-found" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
